<app-icon-registry></app-icon-registry>
<main [@routerTransition]="orientation" *ngIf="apolloLoaded">
  <router-outlet #outlet="outlet"></router-outlet>
</main>
<app-loader *ngIf="loader || !apolloLoaded"></app-loader>
<app-loader *ngIf="concurrentLoader || !apolloLoaded"></app-loader>
